import { dashboardService } from "../../../../Api/Services/DashboardService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import { IEmployeeDashboardPopUpServiceRepsonse } from "../../types";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";

export const fetchEmployeeDashboardPopUp = createServiceAsyncThunk<
  IEmployeeDashboardPopUpServiceRepsonse,
  { userId: number }
>(
  ACTION_NAMES.FETCH_EMPLOYEE_DASHBOARD_POP_UP_DETAILS,
  ({ userId }) => dashboardService.getDashboardPopUp(userId),
  ERROR_MESSAGES.FETCH_EMPLOYEE_DASHBOARD_POP_UP_FAILURE
);

const employeeDashboardPopUpSlice = createGenericSlice<
  IEmployeeDashboardPopUpServiceRepsonse,
  { userId: number }
>(SLICE_NAMES.EMPLOYEE_DASHBOARD_POP_UP, fetchEmployeeDashboardPopUp);

export const {
  clearError: clearEmployeeDashboardPopUpErrors,
  clearSuccessMessage: clearEmployeeDashboardPopUpSuccess,
} = employeeDashboardPopUpSlice.actions;

export default employeeDashboardPopUpSlice.reducer;
